import { Box, Button, Divider, Heading, Center, Flex } from '@chakra-ui/react';
import { InputControl } from 'formik-chakra-ui';
import { useNavigate } from 'react-router';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import Swal from 'sweetalert2';
import * as yup from 'yup';

// Components
import { postData } from '../../Services/api';

// Images
import ImageBackground from '../../Assets/FondoLogin/gradientLogin.svg';

// Validate login
let validationSchema = yup.object().shape({
    user: yup.string().required('El campo es obligatorio'),
    password: yup.string().required('El campo es obligatorio'),
});

const Login = () => {

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async({user, password}) => {
        setLoading(true);
        const login = await postData('login', {user, password});

        if (login?.OK === true) {
            localStorage.setItem('login', login.OK);
            localStorage.setItem('infoUser', JSON.stringify(login.DATA));
            setLoading(false);
            if (login.DATA?.rol === 'Disenador') {
                navigate('/Admin/equipos');
            } else {
                navigate('/Admin/Dashboard');
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Revisa tus credenciales e intentalo de nuevo !',
                timerProgressBar: true,
                timer: 3000,
            });
            setLoading(false);
        }
    };

    return (
        <Flex h='100vh' alignItems='center' backgroundImage={ImageBackground} backgroundSize="cover" backgroundPosition='center' backgroundRepeat="no-repeat">
            <Box boxShadow='xl' mx='auto' w={['90%','90%','50%','40%','40%']} border='2px solid white' borderRadius='12px' backdropFilter='auto' backdropBlur='15px'>
                <Center>
                    <Box w='90%' py='10' >
                        <Heading className="Title" textAlign={'center'}>
                            INICIAR SESIÓN
                        </Heading>

                        <Divider my="3" borderColor='black' />

                        <Formik
                            initialValues={{
                                user: '',
                                password: '',
                            }}
                            validationSchema={ validationSchema }
                            onSubmit={(values) => {
                                handleSubmit(values)
                            }}
                        >
                            <Form>
                                <InputControl name="user" borderColor='black' className='Subtitle' label="Usuario" type="text" inputProps={{type:"text", disabled: false}} mb="5" />
                                <InputControl name="password" borderColor='black' className='Subtitle' label="Contraseña" inputProps={{type:"password", disabled: false}} mb="5" />

                                <Button w="100%" className='Title' borderRadius={'30px'} color="white" type="submit" isLoading={loading} loadingText='Validando...' mt="4" bg='#FF3D00' _hover={{bg: 'white', border: '1px solid #FF3D00', color: '#FF3D00'}}>
                                    INGRESAR
                                </Button>
                            </Form>
                        </Formik>
                    </Box>
                </Center>
            </Box>
        </Flex>
    )
}

export default Login